import { apiPost, apiDelete, apiGet } from '../../../adapters/api-client/api';

export interface ConsentRecord {
  parentId: string;
  childId: string;
  consentType: string;
  version: string;
  granted: boolean;
  grantedAt: string;
  revokedAt?: string;
  ipAddress: string;
}

export interface GrantConsentResponse {
  message: string;
  consent: ConsentRecord;
}

export interface ConsentsResponse {
  consents: ConsentRecord[];
}

export function grantConsent(
  childId: string,
  consentType: string,
  version: string,
): Promise<GrantConsentResponse> {
  return apiPost<GrantConsentResponse>('/api/v1/consent', {
    childId,
    consentType,
    version,
  });
}

export function revokeConsent(childId: string, consentType: string): Promise<void> {
  return apiDelete<void>(`/api/v1/consent/${childId}/${consentType}`);
}

export function getConsentsForChild(childId: string): Promise<ConsentsResponse> {
  return apiGet<ConsentsResponse>(`/api/v1/consent/${childId}`);
}

export function getAllConsents(): Promise<ConsentsResponse> {
  return apiGet<ConsentsResponse>('/api/v1/consent');
}
